export default __webpack_public_path__ + "static/media/57_4_0.cd98ed44.png";